import type { QueueEntryStatus } from '../model';

/** How the wizard presents a queue entry's standing: its word, its colour, and the strip it sits in. */

export type QueueRowState = 'reviewing' | 'waiting' | 'imported' | 'skipped';

export function queueRowState(
    status: QueueEntryStatus,
    isCurrent: boolean
): QueueRowState {
    if (status.kind === 'imported') {
        return 'imported';
    }
    if (status.kind === 'skipped') {
        return 'skipped';
    }
    return isCurrent ? 'reviewing' : 'waiting';
}

/** The status word's colour: where each entry stands. */
export const QUEUE_STATE_COLOR: Record<QueueRowState, string> = {
    reviewing: 'primary.main',
    waiting: 'text.disabled',
    imported: 'success.main',
    skipped: 'warning.main',
};

/** The status word itself. The union member is an internal name, never the text on screen. */
export const QUEUE_STATE_LABEL_ID: Record<QueueRowState, string> = {
    reviewing: 'patientList.import.queue.state.reviewing',
    waiting: 'patientList.import.queue.state.waiting',
    imported: 'patientList.import.queue.state.imported',
    skipped: 'patientList.import.queue.state.skipped',
};

/** Geometry of the full-width strips above the dataset tree. Tint and type scale stay with each strip. */
export const statusStripSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    py: 1.25,
    px: 2.5,
    borderBottom: 1,
    borderColor: 'divider',
} as const;
